import React, { useState } from 'react';
import ButtonOptions from '../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../components/NovoSistema/HeaderButtons';
import CalculoDoFluxoDeCaixa from './CalculoDoFluxoDeCaixa';
import OutrosGastos from './OutrosGastos';
import PrevisaoDeHoras from './PrevisaoDeHoras';
import RacionalDeOutrosGastos from './RacionalDeOutrosGastos';
import ReceitasEResultados from './ReceitasEResultados';

export default function CompisicaoDoPreco() {
  const [option, setOption] = useState('Previsão de Horas');
  return (
    <main>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Previsão de Horas"
          border="#30336b"
          active={option === 'Previsão de Horas' ? true : false}
          yourFunction={() => setOption('Previsão de Horas')}
        />
        <ButtonOptions
          buttonName="Outros Gastos"
          border="#30336b"
          active={option === 'Outros Gastos' ? true : false}
          yourFunction={() => setOption('Outros Gastos')}
        />
        <ButtonOptions
          buttonName="Racional de Outros Gastos"
          border="#30336b"
          active={option === 'Racional de Outros Gastos' ? true : false}
          yourFunction={() => setOption('Racional de Outros Gastos')}
        />
        <ButtonOptions
          buttonName="Receitas e Resultados"
          border="#30336b"
          active={option === 'Receitas e Resultados' ? true : false}
          yourFunction={() => setOption('Receitas e Resultados')}
        />
        <ButtonOptions
          buttonName="Cálculo do Fluxo de Caixa"
          border="#30336b"
          active={option === 'Cálculo do Fluxo de Caixa' ? true : false}
          yourFunction={() => setOption('Cálculo do Fluxo de Caixa')}
        />
      </HeaderButtons>
      {option === 'Previsão de Horas' && <PrevisaoDeHoras />}
      {option === 'Outros Gastos' && <OutrosGastos />}
      {option === 'Racional de Outros Gastos' && <RacionalDeOutrosGastos />}
      {option === 'Receitas e Resultados' && <ReceitasEResultados />}
      {option === 'Cálculo do Fluxo de Caixa' && <CalculoDoFluxoDeCaixa />}
    </main>
  );
}
